import { getUserPreference, setUserPreference } from '../utilities/common'
import { commonServerInstance, downloadInstance } from '../utilities/instances'
import { initGa4Session, endGa4Session } from '../utilities/analytics'

export type CustomerData = {
  address: string
  alias: string
  id: number
  partner_id: number
  receipt_name: string
}

export type LoginData = {
  area: string
  city_id: number
  client_id: number | null
  client_secret: string | null
  email: string
  id: string
  invalid_attempt: number
  ip_list: string | null
  is_active: number
  level: number | null
  managed_customers_data: CustomerData[]
  old_area: string | null
  partner_id: number | null
  partner_name: string | null
  team: string
  token: string
  username: string
}

export const userLogin = (username: string, password: string) => {
  return commonServerInstance
    .post(`/login`, {
      username: username,
      password: password
    })
    .then(res => {
      const data: LoginData = res.data.data
      setUserPreference(data.token)
      if (typeof data.client_id === 'number')
        window.localStorage.setItem('client_id', String(data.client_id))
      if (data.client_secret)
        window.localStorage.setItem('client_secret', data.client_secret)
      window.localStorage.setItem('warehouse', '1') // TODO
      window.localStorage.setItem(
        'customer_info',
        JSON.stringify(data.managed_customers_data ?? {})
      )
      commonServerInstance.defaults.headers.common['Authorization'] =
        `Bearer ${data.token}`
      downloadInstance.defaults.headers.common['Authorization'] =
        `Bearer ${data.token}`
      if (data.id) {
        window.localStorage.setItem('ga_user_id', data.id)
        initGa4Session(data.id)
      }
    })
}

export type TokenExchangeResponse = {
  status?: 'user_not_found'
  ms_email?: string
  ms_display_name?: string
  id?: string
  username?: string
  email?: string
  token?: string
  rolename?: string
}

export const userSsoLogin = async (
  idToken: string
): Promise<TokenExchangeResponse> => {
  const res = await commonServerInstance.post('/token-exchange', {
    id_token: idToken
  })
  const data: TokenExchangeResponse = res.data.data

  if (data.token) {
    setUserPreference(data.token)
    // SSO is for staff accounts only — no client_id/client_secret/managed_customers_data
    window.localStorage.setItem('warehouse', '1')
    window.localStorage.setItem('customer_info', JSON.stringify([]))
    commonServerInstance.defaults.headers.common['Authorization'] =
      `Bearer ${data.token}`
    downloadInstance.defaults.headers.common['Authorization'] =
      `Bearer ${data.token}`
    if (data.id) {
      window.localStorage.setItem('ga_user_id', data.id)
      initGa4Session(data.id)
    }
  }

  return data
}

let logoutInProgress = false

export const userLogout = async () => {
  if (logoutInProgress) return
  logoutInProgress = true

  try {
    if (getUserPreference().authToken) {
      try {
        await commonServerInstance.post('/logout')
      } catch (error) {
        console.error('Logout API failed', error)
      }
    }
    endGa4Session()
    setUserPreference('')
    const username = window.localStorage.getItem('username')
    window.localStorage.clear()
    if (username) window.localStorage.setItem('username', username)

    sessionStorage.clear()

    window.location.replace('/login')
  } finally {
    logoutInProgress = false
  }
}
